import useScrollRestoration from 'hooks/common/useScrollRestoration';
import PAGES from 'pages/registry';
import { useEffect, useRef } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import TABS from 'tabs/registry';

function Navigation() {
  const navigate = useNavigate();
  const { store } = useScrollRestoration();
  const initedRef = useRef(false);

  useEffect(() => {
    if (initedRef.current) return;
    initedRef.current = true;

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function init() {
    // React 탭을 Webapp Transition 모듈에 등록.
    TABS.forEach((tab) => {
      Transition.registerTab(tab.path, {
        start: (data: any, isReactTabNavigation: boolean) => {
          navigate(tab.path, { state: data, replace: isReactTabNavigation });
        },
        show: (data: any, isReactTabNavigation: boolean) => {
          if (!isReactTabNavigation) {
            navigate(-1);
          }
        },
        stop: (isReactTabNavigation: boolean) => {
          if (!isReactTabNavigation) {
            const history = Transition.getHistory();
            if (history.length > 1 && history[history.length - 1].page) {
              // 마지막 히스토리가 페이지인 경우 navigate(-1)을 호출하면 숨겨둔 react page가 보여지게 되므로 그냥 리턴한다.
              return;
            }
            navigate(-1);
          }
        },
        hide: (isReactTabNavigation: boolean) => {
          store(tab.path);
          if (!isReactTabNavigation) {
            navigate('/');
          }
        }
      });
    });
    // React 페이지를 Webapp Transition 모듈에 등록.
    PAGES.forEach((page) => {
      Transition.registerPage(page.path, {
        path: page.path,
        show: (data: any, type: 'push' | 'pop', isReactPageNavigation: boolean) => {
          if (type === 'push') {
            navigate(page.path, { state: data });
          } else {
            if (!isReactPageNavigation) {
              navigate(-1);
            }
          }
        },
        hide: (type: 'hide' | 'dispose' | 'reset', isReactPageNavigation: boolean) => {
          if (type === 'hide' || type === 'reset') {
            store(page.path);
            if (!isReactPageNavigation) {
              navigate('/');
            }
          } else {
            navigate(-1);
          }
        },
      });
    });

    // vanila.js 에서 useNavigate 사용하도록
    Transition.setNavigate(navigate);
  }

  return (
    <>
      <Routes>
        {PAGES.map((page, index) => (
          <Route key={index} path={page.path} element={<page.element />} />
        ))}
        {TABS.map((tab, index) => (
          <Route key={index} path={tab.path} element={ <tab.element />} />
        ))}
      </Routes>
    </>
  );
}

export default Navigation;
